"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.RedwoodProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactHelmetAsync = require("react-helmet-async");

const RedwoodProvider = ({
  children
}) => {
  return /*#__PURE__*/_react.default.createElement(_reactHelmetAsync.HelmetProvider, {
    context: global.__REDWOOD__HELMET_CONTEXT
  }, children);
};

exports.RedwoodProvider = RedwoodProvider;